export default __webpack_public_path__ + "neighborhoods-guide-banner-mobile.svg?64a02fd24b041817d5f78c01fdf4900b";